import React from 'react';
import { 
  User, 
  Bell,
  Gift,
  ShoppingBag,
  ListOrdered,
  Settings as SettingsIcon, 
  Globe, 
  Lock, 
  Phone, 
  ChevronRight, 
  LogOut,
  Car,
  Info,
  CreditCard,
  UserMinus
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SettingsScreen = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Header */}
      <div className="px-4 py-4 bg-white border-b">
        <h1 className="text-xl font-bold">Setări</h1>
      </div>

      <div className="flex-1 px-4 py-6">
        {/* Profile Section */}
        <div className="bg-white rounded-lg shadow mb-6">
          <div className="p-4 flex items-center">
            <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center">
              <User size={32} className="text-gray-500" />
            </div>
            <div className="ml-4 flex-1">
              <h2 className="font-semibold text-lg">John Doe</h2>
              <p className="text-gray-500 text-sm">+40 712 345 678</p>
              <p className="text-gray-500 text-sm">Cluj-Napoca, Romania</p>
            </div>
            <button onClick={() => navigate('/personal-info-edit')} className="px-4 py-2 text-sm text-green-600 border border-green-600 rounded-lg">
              Edit
            </button>
          </div>
        </div>


        {/* Settings List */}
        <div className="space-y-4">
          {/* Account Settings */}
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="px-4 py-3 text-sm font-medium text-gray-500 bg-gray-50">
              CONT
            </div>
            <div className="divide-y divide-gray-100">
              <button onClick={() => navigate('/anunturi')} className="w-full px-4 py-3 flex items-center justify-between hover:bg-gray-50">
                <div className="flex items-center">
                  <Lock className="w-5 h-5 text-gray-500" />
                  <span className="ml-3">Anunturile Mele</span>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400" />
              </button>

              <button onClick={() => navigate('/cards')} className="w-full px-4 py-3 flex items-center justify-between hover:bg-gray-50">
                <div className="flex items-center">
                  <CreditCard className="w-5 h-5 text-gray-500" />
                  <span className="ml-3">Cardurile Mele</span>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400" />
              </button>
            </div>
          </div>

          {/* Notifications */}
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="px-4 py-3 text-sm font-medium text-gray-500 bg-gray-50">
              NOTIFICĂRI
            </div>
            <div className="divide-y divide-gray-100">
              <button className="w-full px-4 py-3 flex items-center justify-between hover:bg-gray-50">
                <div className="flex items-center">
                  <Bell className="w-5 h-5 text-gray-500" />
                  <span className="ml-3">Notificări push</span>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400" />
              </button>
              <button className="w-full px-4 py-3 flex items-center justify-between hover:bg-gray-50">
                <div className="flex items-center">
                  <SettingsIcon className="w-5 h-5 text-gray-500" />
                  <span className="ml-3">Preferințe comunicare</span>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-400" />
              </button>
            </div>
          </div>

          {/* App Settings */}
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="px-4 py-3 text-sm font-medium text-gray-500 bg-gray-50">
              APLICAȚIE
            </div>
            <div className="divide-y divide-gray-100">
              <button className="w-full px-4 py-3 flex items-center justify-between hover:bg-gray-50">
                <div className="flex items-center">
                  <Globe className="w-5 h-5 text-gray-500" />
                  <span className="ml-3">Limba aplicației</span>
                </div>
                <div className="flex items-center">
                  <span className="text-sm text-gray-500 mr-2">Română</span>
                  <ChevronRight className="w-5 h-5 text-gray-400" />
                </div>
              </button>
            </div>
          </div>


        {/* Partner Box */}
        <div className="bg-gradient-to-r from-blue-50 to-emerald-50 rounded-lg shadow mb-6 p-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <Car className="w-10 h-10 text-blue-600" />
            </div>
            <div className="flex-1 ml-4">
              <h2 className="text-xl font-bold text-gray-800">Alătură-te Echipei Noastre</h2>
              <p className="text-gray-600 text-sm">Primește comenzi direct în aplicație</p>
            </div>
            <button 
              onClick={() => navigate('/become-partner')}
              className="ml-4 p-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors flex-shrink-0"
            >
              <Info className="w-5 h-5" />
            </button>
          </div>
        </div>
        

          {/* Logout Button */}
          <button onClick={() => navigate('/login')} className="w-full mt-6 px-4 py-3 flex items-center justify-center text-red-600 bg-white rounded-lg shadow hover:bg-gray-50">
            <LogOut className="w-5 h-5 mr-2" />
            <span>Deconectare</span>
          </button>
          <button onClick={() => navigate('/delete-account')} className="w-full mt-6 px-4 py-3 flex items-center justify-center text-grey-600 bg-white rounded-lg shadow hover:bg-gray-50">
            <UserMinus className="w-5 h-5 mr-2" />
            <span>Sterge contul</span>
          </button>

          {/* App Version */}
          <div className="text-center text-sm text-gray-500 mt-4">
            Versiune 1.0.0
          </div>


        </div>
      </div>
    </div>
  );
};

export default SettingsScreen;